import { Player } from '@/context/JackpotProvider'
import { groupBy } from './groupBy'

export const getGroupedPlayers = (players: Player[], pool: string) => {
  return Object.entries(groupBy(players, (player) => player.address)).map(([key, value]) => {
    const amount = (value as Player[])
      .map((v) => v.amount)
      .reduce((prev, curr) => {
        return (parseInt(prev) + parseInt(curr)).toString()
      }, '0')

    return {
      address: key,
      amount,
      chance: ((parseInt(amount) / parseInt(pool)) * 100).toFixed(2),
    }
  })
}
